module.exports = __webpack_public_path__ + "static/media/hotel_holy.69810358.png";